import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LineItem from './LineItem';
import { categoryMeta } from '../data/budgetItems';
import { formatCurrency } from '../utils/calculations';

const { FiChevronDown } = FiIcons;

function BudgetSection({ category, items, onUpdate }) {
  const categoryTotal = items
    .filter((item) => item.enabled)
    .reduce((sum, item) => sum + item.quantity * item.rate, 0);
  const enabledCount = items.filter((item) => item.enabled).length;
  const meta = categoryMeta[category];

  return (
    <details className="budget-section" open>
      <summary>
        <div
          className="category-indicator"
          style={{ backgroundColor: meta.color }}
        />
        <div className="category-copy">
          <strong>{category}</strong>
          <span>{meta.description}</span>
        </div>
        <div className="category-stats">
          <span>{enabledCount} selected</span>
          <strong>{formatCurrency(categoryTotal)}</strong>
        </div>
        <SafeIcon icon={FiChevronDown} className="chevron" />
      </summary>

      <div className="line-list">
        {items.map((item) => (
          <LineItem
            key={item.id}
            item={item}
            onUpdate={(field, value) => onUpdate(item.id, field, value)}
          />
        ))}
      </div>
    </details>
  );
}

export default BudgetSection;